(function () {
  var source = document.querySelector('[data-global-review-count]');
  if (!source) return;

  var total = Number.parseInt(source.dataset.globalReviewCount, 10);
  if (!Number.isFinite(total) || total < 0) return;

  function findAggregateTotal() {
    var candidates = document.querySelectorAll(
      '.jdgm-all-reviews-text, [class*="jdgm-all-reviews"], .jdgm-widget'
    );
    var highest = total;

    candidates.forEach(function (candidate) {
      var match = (candidate.textContent || '').match(/(?:from\s+)?([\d,]+)\s+reviews?/i);
      if (!match) return;

      var value = Number.parseInt(match[1].replace(/,/g, ''), 10);
      if (Number.isFinite(value) && value > highest) highest = value;
    });

    total = highest;
  }

  function updateBadges(root) {
    findAggregateTotal();
    var label = total === 1 ? '1 review' : total + ' reviews';
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll('.jdgm-prev-badge');

    badges.forEach(function (badge) {
      badge.dataset.numberOfReviews = String(total);

      var text = badge.querySelector('.jdgm-prev-badge__text');
      if (text && text.textContent.trim() !== label) {
        text.textContent = label;
      }
    });
  }

  function init() {
    updateBadges(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          if (node.matches('.jdgm-prev-badge')) {
            updateBadges(node.parentElement);
          } else if (node.querySelector('.jdgm-prev-badge')) {
            updateBadges(node);
          }
        });

        if (
          mutation.target.nodeType === Node.ELEMENT_NODE &&
          mutation.target.closest('.jdgm-prev-badge')
        ) {
          updateBadges(mutation.target.closest('.jdgm-prev-badge').parentElement);
        }
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
